<template>
  <div class="flex flex-col my-4">
    <div
      class="w-full text-left text-sm text-grey mb-4"
      v-for="history in histories"
      :key="history.id"
    >
      <div class="flex justify-between">
        <span>
          <span class="text-brand underline font-semibold"
            >{{ history[0].user.first_name }}
            {{ history[0].user.last_name }}</span
          >
          {{ history[0].event }} this task
        </span>
        <span class="text-xs">{{ calendarFormat(history[0].updated_at) }}</span>
      </div>
      <task-history-item
        v-if="history.length > 1"
        :histories="history"
      ></task-history-item>
    </div>
  </div>
</template>

<script>
import TaskHistoryItem from "./HistoryItem.vue";
import moment from "moment";

export default {
  name: "TaskHistory",
  components: {
    TaskHistoryItem,
  },
  props: ["histories"],
  methods: {
    calendarFormat(date) {
      return moment(date).calendar();
    },
  },
};
</script>
